import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import styled from 'styled-components';
import CS from '@/styles/componentStyled';
import TitleTextBox from '@/component/TitleTextBox';
import { dashboardFacilityRecoil } from '@/atom/DashboardAtom';
import Chart from 'react-apexcharts';

const DailyEventNum = () => {
  const dashboardFacilityState = useRecoilValue(dashboardFacilityRecoil);

  const barValues = [
    Number(dashboardFacilityState?.dailyEvents[0].eventCount ?? 0),
    Number(dashboardFacilityState?.dailyEvents[1].eventCount ?? 0),
    Number(dashboardFacilityState?.dailyEvents[2].eventCount ?? 0),
  ];
  const barXLabels = [
    String(dashboardFacilityState?.dailyEvents[0].date.slice(5) ?? ''),
    String(dashboardFacilityState?.dailyEvents[1].date.slice(5) ?? ''),
    String(dashboardFacilityState?.dailyEvents[2].date.slice(5) ?? ''),
  ];
  const barSeries = [
    {
      name: 'Inflation',
      data: barValues,
    },
  ];
  const barOptions: ApexCharts.ApexOptions = {
    chart: {
      height: 350,
      type: 'bar',
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 2,
        columnWidth: '20%',
        dataLabels: {
          position: 'top',
        },
      },
    },
    dataLabels: {
      enabled: true,
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#304758'],
      },
    },
    xaxis: {
      categories: barXLabels,
      position: 'bottom',
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      crosshairs: {
        fill: {
          type: 'gradient',
          gradient: {
            colorFrom: '#D8E3F0',
            colorTo: '#BED1E6',
            stops: [0, 100],
            opacityFrom: 0.4,
            opacityTo: 0.5,
          },
        },
      },
      tooltip: {
        enabled: true,
      },
    },
    yaxis: {
      labels: {
        formatter: function (value: number) {
          return Math.floor(value).toString();
        },
      },
    },
  };

  return (
    <>
      <CntBox className="flex fdc">
        <TitleTextBox text="일일 이벤트 발생 건수" />
        <div className="chart-box">
          <Chart
            options={barOptions}
            series={barSeries}
            type="bar"
            height="100%"
          />
        </div>
      </CntBox>
    </>
  );
};

export default DailyEventNum;

export const CntBox = styled(CS.CntBoxType1)`
  flex: 1 1 0%;
  gap: 10px;
`;
